<template>
  <div>

    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-purple">
          <el-card class="box-card" shadow="hover">
            <div slot="header" class="clearfix" style="border: none">
              <i class="el-icon-card-header"></i>
              <span>药物统计</span>
            </div>
            <el-row :gutter="20">
              <el-col :span="12">
                <PieChart id="clinic_drug_count_pie"
                          :params="{'clinic_id':this.clinic_id}"
                          height="400px"
                          width="100%"
                          path="clinic_drug_count_pie"></PieChart>
              </el-col>
              <el-col :span="12">
                <PieChart id="clinic_drug_fee_pie"
                          :params="{'clinic_id':this.clinic_id}"
                          height="400px"
                          width="100%"
                          path="clinic_drug_fee_pie"></PieChart>
              </el-col>
            </el-row>
          </el-card>
        </div>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-purple">
          <el-card class="box-card" shadow="hover">
            <div slot="header" class="clearfix" style="border: none">
              <i class="el-icon-card-header"></i>
              <span>药物+穴位+克数</span>
            </div>
            <el-row>
              <el-table
                  :data="clinic_drug_acu_g_list"
                  max-height="500px"
                  :header-cell-style="{background:'#363944',color:'white',border:'none'}"
                  :row-class-name="tableRowClassName">
                <el-table-column prop="group_acupoint" label="穴位"></el-table-column>
                <el-table-column prop="drug_name" label="药物名称"></el-table-column>
                <el-table-column prop="number" label="克数"></el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button @click="show_acu_drug_g(scope.row)" type="text" style="color: rgb(46, 205, 129);" size="small">治疗信息(全量)</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-row>
          </el-card>
        </div>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-purple">
          <el-card class="box-card" shadow="hover">
            <div slot="header" class="clearfix" style="border: none">
              <i class="el-icon-card-header"></i>
              <span>药物列表（私库）</span>
            </div>
            <el-row>
              <el-table
                  :data="clinic_drug_list"
                  max-height="500px"
                  :header-cell-style="{background:'#363944',color:'white',border:'none'}"
                  :row-class-name="tableRowClassName">
                <el-table-column prop="drug_id" label="药物id"></el-table-column>
                <el-table-column prop="drug_name" label="药物名称"></el-table-column>
                <el-table-column prop="drug_spec" label="药物规格"></el-table-column>
                <el-table-column prop="drug_manu" label="厂商"></el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button @click="show_drug(scope.row)" type="text" style="color: rgb(46, 205, 129);" size="small">详细信息</el-button>
                    <el-button @click="show_func(scope.row)" type="text" style="color: rgb(46, 205, 129);" size="small">药物治疗信息(全量)</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-row>
          </el-card>
        </div>
      </el-col>
    </el-row>


    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-purple">
          <el-card class="box-card" shadow="hover">
            <div slot="header" class="clearfix" style="border: none">
              <i class="el-icon-card-header"></i>
              <span>穴位</span>
            </div>
            <el-row>
              <el-table
                  :data="xuewei_list"
                  max-height="500px"
                  :header-cell-style="{background:'#363944',color:'white',border:'none'}"
                  :row-class-name="tableRowClassName">
                <el-table-column prop="group_acupoint" label="穴位名称"></el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button @click="show_acu(scope.row)" type="text" style="color: rgb(46, 205, 129);" size="small">治疗信息(全量)</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-row>
          </el-card>
        </div>
      </el-col>
    </el-row>


    <!-- custom-class 与处方列表弹窗一致，走 main.js 引入的 clinic-cf-dialog.css -->
    <el-dialog
      title="药物信息"
      :visible.sync="drugDialogTableVisible"
      width="50%"
      append-to-body
      custom-class="clinic-cf-dialog"
    >
      <el-row :gutter="20" class="drug-dialog-info">
        <div v-for="(item,key) in drug_info" :key="key" class="text item">
          <el-col :span="3" class="el-col-tbl-key">{{ key }}</el-col>
          <el-col :span="9" class="el-col-tbl-val">{{ item }}</el-col>
        </div>
      </el-row>
    </el-dialog>

    <el-dialog
      :title="'药物治疗信息('+this.drug_name+')'"
      :visible.sync="funcDialogTableVisible"
      width="75%"
      append-to-body
      custom-class="clinic-cf-dialog"
    >
      <PieChart id="clinic_drug_func_pie"
                :params="{'drug_id':this.drug_id,'drug_name':this.drug_name}"
                height="400px"
                :key="drug_id"
                width="100%"
                path="clinic_drug_func_pie"></PieChart>
    </el-dialog>
    <el-dialog
      :title="'穴位治疗信息('+this.group_acupoint+')'"
      :visible.sync="acuDialogTableVisible"
      width="75%"
      append-to-body
      custom-class="clinic-cf-dialog"
    >
      <PieChart id="clinic_acu_pie"
                :params="{'group_acupoint':this.group_acupoint}"
                height="400px"
                :key="group_acupoint"
                width="100%"
                path="clinic_acu_pie"></PieChart>
    </el-dialog>
    <el-dialog
      :title="'联合治疗信息('+this.group_acupoint+'+'+this.number+'g+'+this.drug_name+')'"
      :visible.sync="acuDrugGDialogTableVisible"
      width="75%"
      append-to-body
      custom-class="clinic-cf-dialog"
    >
      <PieChart id="clinic_acu_pie"
                :params="{'group_acupoint':this.group_acupoint,'drug_name':this.drug_name,'number':this.number}"
                height="400px"
                :key="group_acupoint+number+drug_name"
                width="100%"
                path="clinic_acu_drug_g_pie"></PieChart>
    </el-dialog>
  </div>
</template>

<script>
import '@/assets/css/main.css';
import PieChart from "@/views/charts/pie";

export default {
  name: "ClinicDrugStat",
  components: {
    PieChart
  },
  data() {
    return {
      clinic_drug_list: null,
      clinic_drug_acu_g_list: null,
      xuewei_list: null,
      // clinic_id: '1650588070122270721',
      clinic_id: this.$route.query.clinic_id ? this.$route.query.clinic_id : '1650588070122270721',
      drug_id: '',
      drug_name: '',
      number: '',
      group_acupoint: '',
      drugDialogTableVisible: false,
      funcDialogTableVisible: false,
      acuDialogTableVisible: false,
      acuDrugGDialogTableVisible: false,
      drug_info: null,
    }
  },
  mounted() {
    this.get_clinic_drug_list();
    this.get_clinic_xuewei_list();
    this.get_clinic_drug_acu_g_list();
  },
  methods: {
    get_clinic_drug_list() {
      this.$http.get(process.env.VUE_APP_API_HOST + "/get_clinic_drug_list?clinic_id="
          + this.clinic_id).then((res) => {
        this.clinic_drug_list = res.data.data
      })
    },
    get_clinic_xuewei_list() {
      this.$http.get(process.env.VUE_APP_API_HOST + "/get_clinic_xuewei_list?clinic_id="
          + this.clinic_id).then((res) => {
        this.xuewei_list = res.data.data
      })
    },
    get_clinic_drug_acu_g_list() {
      this.$http.get(process.env.VUE_APP_API_HOST + "/get_clinic_drug_acu_g_list?clinic_id="
          + this.clinic_id).then((res) => {
        this.clinic_drug_acu_g_list = res.data.data
      })
    },
    show_drug(row) {
      let params = {"clinic_id": this.clinic_id, "drug_id": row.drug_id, "drug_name": row.drug_name}
      this.$http.post(process.env.VUE_APP_API_HOST + "/get_drug_info", params).then((res) => {
        this.drug_info = res.data.data
      })
      this.drugDialogTableVisible = true
    },
    show_func(row) {
      this.drug_id = row.drug_id
      this.drug_name = row.drug_name
      this.funcDialogTableVisible = true
    },
    show_acu(row) {
      this.group_acupoint = row.group_acupoint
      this.acuDialogTableVisible = true
    },
    show_acu_drug_g(row) {
      this.group_acupoint = row.group_acupoint
      this.drug_name = row.drug_name
      this.number = row.number
      this.acuDrugGDialogTableVisible = true
    },
    tableRowClassName({rowIndex}) {
      if (rowIndex % 2 == 1) {
        return 'warning-row1';
      } else if (rowIndex % 2 == 0) {
        return 'success-row1';
      }
      return '';
    },
  },
}
</script>

<style scoped>
/** 药物信息弹窗内列表条：与深色弹底协调，替代原内联 #363944 */
.drug-dialog-info {
  background-color: rgba(0, 0, 0, 0.22);
  border-radius: 8px;
  padding: 8px 4px;
  box-sizing: border-box;
}

.el-table /deep/ tbody tr:hover {
  color: black !important
}

.el-table /deep/ .warning-row1 {
  background: #363944;
}

.el-table /deep/ .warning-row1 > td {
  border: none;
}

.el-table /deep/ .success-row1 {
  background: #3C3F4A;
}

.el-table /deep/ .success-row1 > td {
  border: none;
}

.el-card /deep/ .el-card__header {
  border-bottom: none;
  height: 40px;
  padding: 10px 20px;
}

.el-card /deep/ .el-card__body {
  background-color: #363944;
}


.el-card /deep/ .el-card__header {
  border-bottom: none;
  height: 40px;
  padding: 10px 20px;
}

.el-card /deep/ .el-card__body {
  background-color: #363944;
}
</style>
